import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { take } from 'rxjs';
import { ElementAttribute } from '@models/editor';
import { PUMP_ICON_BY_TYPE, PumpType } from '@models/pump';
import { ElementOrientationService } from '@service/canvas/element-orientation.service';

@Component({
    selector: 'app-pump-object-setting',
    templateUrl: './pump-object-setting.component.html',
    styleUrls: ['./pump-object-setting.component.css'],
    standalone: false,
})
export class PumpObjectSettingComponent implements OnChanges {
    @Input() selectedElement;
    @Input() userCanEdit: boolean;

    pumpDirectionItemList: string[] = Object.values(PumpType);
    selectedPumpDirection: string = PumpType.verticalRight;

    constructor(private elementOrientationService: ElementOrientationService) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedElement) this.updatePumpDirectionFromElement();
    }

    onPumpDirectionChange(event: { name: string; value: string }) {
        this.selectedPumpDirection = event.value;
        this.elementOrientationService
            .applyPumpOrientation(this.selectedElement, PUMP_ICON_BY_TYPE[event.value])
            .pipe(take(1))
            .subscribe();
    }

    updatePumpDirectionFromElement() {
        const iconName = this.selectedElement?.getAttribute(ElementAttribute.pumpIcon);
        const pumpType = Object.keys(PUMP_ICON_BY_TYPE).find(type => PUMP_ICON_BY_TYPE[type] === iconName);
        this.selectedPumpDirection = pumpType ?? PumpType.verticalRight;
    }
}
